export default __webpack_public_path__ + "static/background1-acce65f75703dd9776f6fda6aef7ea95.png";